import React, { useCallback, useContext, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import '../styles/SearchPage.css';
import SearchBox from './SearchBox';
import { Container } from 'react-bootstrap';
import SearchPageProductList from './SearchPageProductList';
import SearchPageSidebar from './SearchPageSidebar';
import PageNavCurPageIndicator from './PageNavCurPageIndicator';
import PageNav from './PageNav';
import usePageNav from '../hooks/usePageNav';
import getNavigationInitialState from '../initialState/navigation';
import SEO from './SEO';
import AppContext from './context/AppContext';
import { bool, object } from 'prop-types';
import useSearch from '../hooks/useSearch';

export default function SearchPage({ isMobile, searchBoxRef }) {
    const { appContext } = useContext(AppContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const { searchQuery, updateSearchParams } = useSearch();
    const [searchLoaded, setSearchLoaded] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [productList, setProductList] = useState([]);
    /* End search functionality */
    /* Pagination code */
    const containerRef = useRef(null);
    const [pagesData, setPagesData] = useState(getNavigationInitialState());
    const handlePageChange = (newCurPage) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('page', parseInt(newCurPage));
        setSearchParams(newSearchParams);
    };
    const {
        curPage,
        curRange,
        nextRange,
        generatedPagesData,
        paginateUser,
    } = usePageNav({
        containerRef,
        pagesData,
        initialCurPage: Math.min(parseInt(searchQuery.page || 0, 0)),
        onUpdate: handlePageChange,
    });
    /* End pagination code */

    const searchPageRef = useCallback(() => {
        searchBoxRef.current?.enableAlterPath();
    }, []);

    return (<Container
        ref={searchPageRef}
        fluid>
        <SEO
            seoTitle={'Search results - ' + appContext.config.storeName}
        />
        <br />
        <div
            className={'page--section'}
            style={{ padding: '0',
                maxWidth: '90vw' }}>
            {searchQuery.q && (<h1>Search for &ldquo;{searchQuery.q}&rdquo;</h1>)}
            {!searchQuery.q && (<h1>What are you looking for?</h1>)}
            {(searchQuery.q?.length < 3) && (<p>Please type 3 characters or more to start searching.</p>)}
            <SearchBox
                isMobile={isMobile}
                isPage={true}
                searchLoaded={searchLoaded}
                setSearchLoaded={setSearchLoaded}
                searchLoading={searchLoading}
                setSearchLoading={setSearchLoading}
                searchQuery={searchQuery}
                setSearchQuery={updateSearchParams}
                productList={productList}
                setProductList={setProductList}
                setPagesData={setPagesData} />
            <div
                className={'search-page--inner'}>
                <SearchPageSidebar
                    isMobile={isMobile}
                    searchQuery={searchQuery}
                    setSearchQuery={updateSearchParams}
                    vendorList={pagesData.availableVendors ?? []}
                    tagPrefixes={pagesData.availableTagPrefixes ?? []}
                    tagList={pagesData.availableTagFilters ?? []}
                    productMaxPrice={pagesData.productMaxPrice}
                    searchLoading={searchLoading}
                    productCount={productList.length} />
                <SearchPageProductList
                    ref={containerRef}
                    isMobile={isMobile}
                    productList={productList}
                    searchLoading={searchLoading}>
                    <PageNavCurPageIndicator
                        curRange={curRange}
                        nextRange={nextRange}
                        totalCount={pagesData.count}
                        resourceType={'products'}
                        noStyle={true}
                    />
                </SearchPageProductList>
            </div>
            {productList.length > 0 && (<PageNav
                curPage={curPage}
                totalPages={pagesData.pages}
                generatedPagesData={generatedPagesData}
                paginateUser={paginateUser}
            />)}
        </div>
    </Container>);
}

SearchPage.propTypes = {
    isMobile: bool,
    searchBoxRef: object,
};
